const Constant = {
    backendUrl: process.env.REACT_APP_DATADEX_ENV === 'production' || process.env.REACT_APP_DATADEX_ENV === 'staging' ? process.env.REACT_APP_BACKEND_API_URL : 'http://local.datadex.com:7777',
    apiBaseUrl: process.env.REACT_APP_DATADEX_ENV === 'production' || process.env.REACT_APP_DATADEX_ENV === 'staging' ? process.env.REACT_APP_BACKEND_API_URL : 'http://local.datadex.com:7777/api/v1/',
}

export default Constant;